/* eslint-disable no-console */
import { Component, OnInit, signal, output, effect, Inject } from '@angular/core';
import { SearchBarComponent } from '@/app/shared/search-bar/search-bar.component';
import { DescriptionCardComponent } from '@/app/shared/cards/description-card/description-card.component';
import { ProtocolWithActions } from '@/app/interfaces/protocol';
import { ProtocolsService } from '@/app/services/protocols.service';
import { filtersAdvanced } from '@/app/interfaces/filtersAdvanced';
import { FiltersComponent } from '@/app/shared/filters/filters.component';
import { Protocol } from '@/app/interfaces/protocol';
import { OrganismService } from '@/app/services/masters/organims.service';
import { PaginationComponent } from '@/app/shared/pagination/pagination.component';
@Component({
  selector: 'app-step1',
  imports: [SearchBarComponent, DescriptionCardComponent, FiltersComponent, PaginationComponent],
  templateUrl: './step1.component.html',
})
export class Step1Component implements OnInit {
  constructor(
    private protocolsService: ProtocolsService,
    @Inject(OrganismService) private organismService: OrganismService
  ) {}
  protocolEffect = effect(() => {
    this.currentPage();
    this.paginationSize();
    this.protocols.set([]);
    this.loadProtocols();
  });
  paginationSize = signal(15);
  currentPage = signal(1);
  seachData = signal('');
  dataChange = output<Protocol>();
  viewProtocolDetails = output<number>();
  totalResults = signal(0);
  jobCode = JSON.parse(localStorage.getItem('userData')).roleCode;
  protocols = signal<ProtocolWithActions[]>([]);

  organisms = [];

  advancedFilters: filtersAdvanced[] = [
    {
      type: 'multiselect',
      label: 'Organismos',
      options: this.organisms,
      selected: [],
      key: 0,
    },
  ];

  get filterParams() {
    return [
      {
        basicFilter: {
          currentPage: this.currentPage(),
          sizePages: this.paginationSize(),
          jobCode: this.jobCode,
        },
      },
      {
        advanceFilter: {
          organisms: this.advancedFilters.find((e) => e.label === 'Organismos')?.selected,
          search: this.seachData(),
        },
      },
    ];
  }

  handleSearch(value: string) {
    this.seachData.set(value);
  }

  seeDetails(protocolId) {
    this.viewProtocolDetails.emit(protocolId);
  }

  selectProtocol(protocol: Protocol) {
    if (!protocol?.codigoOrganismoProtocolo) {
      return;
    }
    this.dataChange.emit(protocol);
  }

  handleApplyFilters(e) {
    this.advancedFilters = e;
    this.loadProtocols();
  }

  getOrganismName(codigoOrganismo: string): string {
    const organism = this.organisms.find((org) => org.value === codigoOrganismo);
    return organism ? organism.label : '';
  }

  async loadProtocols() {
    const data = await this.protocolsService.getProtocols(this.filterParams);
    if (data?.items?.length) {
      const protocolsWithActions = data.items.map((protocol) => ({
        ...protocol,
        actions: [
          {
            label: 'Consultar detalle',
            type: 'link',
            action: () => this.seeDetails(protocol.id),
          },
          {
            label: 'Seleccionar',
            type: 'button',
            action: () => this.selectProtocol(protocol),
          },
        ],
      }));

      this.protocols.set(protocolsWithActions);
    } else {
      this.protocols.set([]);
    }
    this.totalResults.set(data.total);
  }

  ngOnInit() {
    this.getOrganisms();
  }
  async getOrganisms() {
    const response = await this.organismService.getOrganism();
    if (response?.data?.items.length) {
      response.data.items.forEach((e) => {
        this.organisms.push({
          label: e.nombre_organismo,
          value: e.codigo_organismo,
          check: false,
        });
      });
    }
  }
}
